module.exports = __webpack_public_path__ + "img/Marquise sur mesure.6609f711.jpg";